// Build Your Pack JavaScript - Using Product Variants

class PackBuilder {
  constructor() {
    // Scope all queries to the currently visible content
    var size = document.documentElement.getAttribute('data-pack-size') || 'no1';
    this.container = document.querySelector('.build-pack-content[data-size="' + size + '"]');
    if (!this.container) return;

    this.selectedVariants = [];
    this.variantQuantities = {};
    this.maxProducts = 3;
    this.isSubmitting = false;
    this.init();
  }

  init() {
    // Reset stale swatch states from any previous instance
    this.container.querySelectorAll('.book-swatch').forEach(swatch => {
      swatch.classList.remove('selected');
      const countEl = swatch.querySelector('.swatch-count');
      if (countEl) {
        countEl.style.display = 'none';
        countEl.textContent = '0';
      }
    });

    this.bindEvents();
    this.updateUI();

    // Initially disable the payment button
    const paymentButtonContainer = this.container.querySelector('.shopify-payment-button');
    if (paymentButtonContainer) {
      paymentButtonContainer.classList.add('disabled');
    }

    // Initialize sticky add to cart
    this.initStickyAddToCart();
  }

  bindEvents() {
    // Create hover overlay image for gallery preview
    const firstSlideContainer = this.container.querySelector('.product-images__slide.is-active .product-single__media-image');
    if (firstSlideContainer) {
      this.hoverOverlay = document.createElement('img');
      this.hoverOverlay.className = 'gallery-hover-overlay';
      this.hoverOverlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;z-index:10;opacity:0;transition:opacity 0.15s ease;pointer-events:none;';
      firstSlideContainer.appendChild(this.hoverOverlay);
    }

    // Book swatch clicks - add to pack
    this.container.querySelectorAll('.book-swatch').forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        if (swatch.classList.contains('sold-out')) return;
        if (this.selectedVariants.length >= this.maxProducts) return;
        this.addVariant(swatch);
      });

      // Hover: show variant image as overlay (desktop only)
      swatch.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches && this.hoverOverlay) {
          const variantImage = swatch.dataset.variantImageLarge;
          if (variantImage) {
            this.hoverOverlay.src = variantImage;
            this.hoverOverlay.style.opacity = '1';
          }
        }
      });

      swatch.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: hover)').matches && this.hoverOverlay) {
          this.hoverOverlay.style.opacity = '0';
        }
      });
    });

    // Pack slots for removal
    this.container.querySelectorAll('.pack-slot').forEach(slot => {
      slot.addEventListener('click', () => {
        if (slot.classList.contains('filled')) {
          this.removeFromSlot(slot);
        }
      });
    });

    // Add pack to cart button
    const addBtn = this.container.querySelector('.select-more-btn');
    if (addBtn) {
      addBtn.addEventListener('click', () => {
        if (this.selectedVariants.length === this.maxProducts) {
          this.addPackToCart();
        }
      });
    }

    // Intercept Shopify payment button
    const paymentButtonContainer = this.container.querySelector('.shopify-payment-button');
    if (paymentButtonContainer) {
      const form = this.container.querySelector('form[id^="build-pack-form"]');
      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          if (this.selectedVariants.length === this.maxProducts) {
            this.addPackToCart(true);
          }
        });
      }
    }
  }

  addVariant(swatchEl) {
    if (this !== window.activePackBuilder) return;
    if (this.isSubmitting) return;
    if (this.selectedVariants.length >= this.maxProducts) return;

    const variantId = swatchEl.dataset.variantId;

    const variant = {
      id: variantId,
      title: swatchEl.dataset.variantTitle,
      price: parseFloat(swatchEl.dataset.variantPrice),
      image: swatchEl.dataset.variantImage,
      swatchEl: swatchEl
    };

    this.selectedVariants.push(variant);
    this.variantQuantities[variantId] = (this.variantQuantities[variantId] || 0) + 1;

    this.updateSwatchUI(swatchEl, variantId);
    this.updateUI();
  }

  removeVariant(variantId) {
    if (this !== window.activePackBuilder) return;
    const index = this.selectedVariants.findIndex(v => v.id === variantId);
    if (index > -1) {
      const variant = this.selectedVariants[index];
      this.selectedVariants.splice(index, 1);
      this.variantQuantities[variantId] = (this.variantQuantities[variantId] || 1) - 1;

      if (variant.swatchEl) {
        this.updateSwatchUI(variant.swatchEl, variantId);
      }
      this.updateUI();
    }
  }

  removeFromSlot(slot) {
    if (this !== window.activePackBuilder) return;
    const slotIndex = parseInt(slot.dataset.slot) - 1;
    if (this.selectedVariants[slotIndex]) {
      const variant = this.selectedVariants[slotIndex];
      const variantId = variant.id;

      this.selectedVariants.splice(slotIndex, 1);
      this.variantQuantities[variantId] = (this.variantQuantities[variantId] || 1) - 1;

      if (variant.swatchEl) {
        this.updateSwatchUI(variant.swatchEl, variantId);
      }

      this.updateUI();
    }
  }

  updateSwatchUI(swatchEl, variantId) {
    const qty = this.variantQuantities[variantId] || 0;
    const countEl = swatchEl.querySelector('.swatch-count');

    if (qty > 0) {
      swatchEl.classList.add('selected');
      if (countEl) {
        countEl.textContent = qty;
        countEl.style.display = 'flex';
      }
    } else {
      swatchEl.classList.remove('selected');
      if (countEl) {
        countEl.style.display = 'none';
      }
    }
  }

  clearPack() {
    this.container.querySelectorAll('.book-swatch').forEach(swatch => {
      swatch.classList.remove('selected');
      const countEl = swatch.querySelector('.swatch-count');
      if (countEl) {
        countEl.style.display = 'none';
        countEl.textContent = '0';
      }
    });

    this.selectedVariants = [];
    this.variantQuantities = {};
    this.updateUI();
  }

  updateUI() {
    this.updateSlots();
    this.updateButton();
  }

  updateSlots() {
    const slots = this.container.querySelectorAll('.pack-slot');

    slots.forEach((slot, index) => {
      const variant = this.selectedVariants[index];

      if (variant) {
        slot.classList.add('filled');
        slot.innerHTML = `
          <div class="slot-placeholder">
            <button class="slot-remove-btn" data-slot-index="${index}">×</button>
            ${variant.image ? `<img src="${variant.image}" alt="${variant.title}" class="slot-image">` : `<span class="slot-number">#${index + 1}</span>`}
          </div>
        `;

        const removeBtn = slot.querySelector('.slot-remove-btn');
        if (removeBtn) {
          removeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.removeFromSlot(slot);
          });
        }
      } else {
        slot.classList.remove('filled');
        slot.innerHTML = `
          <div class="slot-placeholder">
            <span class="slot-number">#${index + 1}</span>
          </div>
        `;
      }
    });
  }

  updateButton() {
    const button = this.container.querySelector('.select-more-btn');
    const paymentButtonContainer = this.container.querySelector('.shopify-payment-button');
    if (!button) return;

    const buttonText = button.querySelector('.select-more-btn--text');
    const remaining = this.maxProducts - this.selectedVariants.length;

    const stickyButton = this.container.closest('.build-pack-content')
      ? this.container.closest('.build-pack-content').querySelector('.sticky-add-to-cart-btn')
      : document.querySelector('.sticky-add-to-cart-btn');
    const stickyButtonText = stickyButton ? stickyButton.querySelector('.single-add-to-cart-button--text') : null;

    if (remaining === 0) {
      buttonText.textContent = 'ADD TO CART';
      button.classList.add('ready');
      button.disabled = false;

      if (stickyButton && stickyButtonText) {
        stickyButtonText.textContent = 'ADD TO CART';
        stickyButton.disabled = false;
        stickyButton.classList.remove('sold-out');
      }

      if (paymentButtonContainer) {
        paymentButtonContainer.classList.remove('disabled');
      }
    } else {
      const text = remaining === 3 ? 'SELECT 3 MORE' :
                  remaining === 1 ? 'SELECT 1 MORE' :
                  `SELECT ${remaining} MORE`;
      buttonText.textContent = text;
      button.classList.remove('ready');
      button.disabled = true;

      if (stickyButton && stickyButtonText) {
        stickyButtonText.textContent = text;
        stickyButton.disabled = true;
        stickyButton.classList.add('sold-out');
      }

      if (paymentButtonContainer) {
        paymentButtonContainer.classList.add('disabled');
      }
    }
  }

  async addPackToCart(useCheckout = false) {
    if (this !== window.activePackBuilder) return;
    if (this.selectedVariants.length !== this.maxProducts) return;
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    const button = this.container.querySelector('.select-more-btn');
    button.disabled = true;
    button.classList.add('loading');

    const packId = 'pack-' + Date.now();

    try {
      // Group variants by ID and count quantities
      const variantCounts = {};
      this.selectedVariants.forEach(variant => {
        variantCounts[variant.id] = (variantCounts[variant.id] || 0) + 1;
      });

      // Create items array with quantities and pack properties
      const items = Object.entries(variantCounts).map(([variantId, quantity]) => ({
        id: parseInt(variantId),
        quantity: quantity,
        properties: {
          '_pack_id': packId,
          '_pack_item': 'yes'
        }
      }));

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const responseData = await response.json();

      if (response.ok) {
        // Verify all 3 items were added
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        const packItems = cartData.items.filter(item => item.properties && item.properties._pack_id === packId);
        const totalAdded = packItems.reduce((sum, item) => sum + item.quantity, 0);

        if (totalAdded < this.maxProducts) {
          const updates = {};
          packItems.forEach(item => { updates[item.key] = 0; });
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          throw new Error('One or more books are no longer available. Please try different selections.');
        }

        if (useCheckout) {
          window.location.href = '/checkout';
        } else {
          window.location.href = '/cart';
        }
      } else {
        console.error('Cart error:', responseData);
        throw new Error(responseData.description || 'Failed to add pack to cart');
      }
    } catch (error) {
      console.error('Error adding pack to cart:', error);

      // Clean up any partial pack items
      try {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        const packItems = cartData.items.filter(item => item.properties && item.properties._pack_id === packId);
        if (packItems.length > 0) {
          const updates = {};
          packItems.forEach(item => { updates[item.key] = 0; });
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      } catch (cleanupError) {
        console.error('Error cleaning up partial pack:', cleanupError);
      }

      alert(error.message || 'Sorry, there was an error adding your pack to the cart. Please try again.');
      this.isSubmitting = false;
      button.disabled = false;
      button.classList.remove('loading');
    }
  }

  initStickyAddToCart() {
    const wrapper = this.container.closest('.build-pack-content');
    const stickyBar = wrapper ? wrapper.querySelector('.build-pack-sticky') : null;
    if (!stickyBar) return;

    const stickyInner = stickyBar.querySelector('.product-add-to-cart-sticky--inner');
    const stickyContent = stickyBar.querySelector('.product-add-to-cart-sticky--content');
    const stickyButton = stickyBar.querySelector('.sticky-add-to-cart-btn');

    if (stickyInner) {
      stickyInner.addEventListener('click', () => {
        stickyInner.classList.toggle('sticky-open');
        stickyContent.classList.toggle('active');
      });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        if (this.selectedVariants.length === this.maxProducts) {
          this.addPackToCart();
        }
      });
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.activePackBuilder = new PackBuilder();
});
